<template>
	<core-page>
		<common-alerts id="dashboard-alerts" :alerts="alerts"/>
		<core-loading v-if="isLoading"/>
		<div class="omapi-dash omapi-card__flex">
			<common-welcomebox
				v-if="!connected"
				:cardType="connected ? 'dismiss' : 'permanent'"
				:learnMore="true"
			>
				Instantly grow your email list, get more leads and increase sales with the #1 most powerful conversion optimization toolkit in the world.
				<template v-slot:afterButtons>
					<core-button
						:href="$urls.docs('getting-started-optinmonster-wordpress-checklist', 'WelcomeBox')"
						class="omapi-create-campaign__link-more"
						target="_blank"
						rel="noopener noreferrer"
						:linkStyle="true"
						:arrow="true"
					>
						Read the Getting Started Guide
					</core-button>
				</template>
			</common-welcomebox>
			<common-welcome-back-box v-else-if="!dismissedWelcomeBack"/>
			<dashboard-stats-widget/>
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__left">
				<dashboard-template-select-widget/>
			</div>
			<div class="omapi-dash__cards-wrapper omapi-dash__cards-wrapper__right">
				<dashboard-top-campaigns-widget/>
				<dashboard-resources-widget/>
			</div>
		</div>
	</core-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	beforeCreate () {
		this.$store.dispatch('dashboard/fetch')
	},
	computed : {
		...mapState([ 'alerts' ]),
		...mapState('dashboard', [ 'dismissedWelcomeBack' ]),
		...mapGetters([ 'connected' ]),
		isLoading () {
			return this.$store.getters.isLoading('plugins')
		},
	},
	methods : {},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/dashboard';
</style>
